import { AbilityBuilder, createMongoAbility } from '@casl/ability';

import { UserRole } from '@/types';
import { cleanFeatureFlags } from '@/utils/clean-feature-flags';

import { AppAbility, Subjects } from './types';

export default function updateAbility(ability: AppAbility, user) {
  const { can, cannot, rules } = new AbilityBuilder<AppAbility>(createMongoAbility);
  const flags = cleanFeatureFlags(user.flags);

  // TODO: Refactor this to use a map of roles to permissions so it can also be reused in the tests
  if (user.role === UserRole.Admin) {
    can('view', 'Proposal Price');
    can('view', 'Total Price');
    can('view', 'GAF Energy Documents');
    can('select', 'Sales Representative');
    cannot('view', 'Sales Representative');
  }

  if (user.role === UserRole.Sales) {
    can('accept', 'Proposal');
    can('view', 'Sales Representative');
    cannot('view', 'Total Price');
    cannot('view', 'Proposal Price');
    cannot('select', 'Sales Representative');
    cannot('view', 'GAF Energy Documents');
  }

  if (user.companyInfo?.isBulkFulfillmentEnabled) {
    can('view', 'Bulk Fulfillment Program');
  }

  can('view', 'Pricing Calculator V2 Detailed view');

  if (user.role === UserRole.Sales && user.companyInfo?.hidePricingForSalesRoles) {
    cannot('view', 'Pricing Calculator V2 Detailed view');
  }

  flags.forEach(flag => {
    can('view', flag as Subjects);
  });

  ability.update(rules);
}
